import { action, observable, makeObservable } from 'mobx';
import {NodeData} from './node-data';

export class TreeNode {
  parent: TreeNode | null;

  children: TreeNode[];

  data: NodeData;

  @observable
  expanded: boolean;

  @observable
  selected: boolean;

  @action
  toggleExpand = () => {
    if (this.children.length > 0 && !this.expanded)
      this.expanded = true;
    else
      this.expanded = false;
  };

  @action
  expand = () => {
    if (this.children.length > 0)
      this.expanded = true;
  };

  @action
  collapse = () => {
    this.expanded = false;
  };

  constructor(parent: TreeNode | null, data: NodeData) {
    makeObservable(this);
    this.parent = parent;
    this.children = [];
    this.data = data;
    this.expanded = false;
    this.selected = false;
  }
}
